import i18n from './i18n'

// Route components
import home from './views/home.vue'
import data_and_business_intelligence from './views/business_intelligence.vue'
import management_and_maintenance from './views/beheer_en_onderhoud.vue'
import cio_as_a_service from './views/cio_as_a_service.vue'
import contact from './views/contact.vue'

const components = {
  home,
  data_and_business_intelligence,
  management_and_maintenance,
  cio_as_a_service,
  contact,
}

const availableLocales = ['en', 'nl']

const routes = [
  {
    path: '/',
    redirect: '/nl'
  }
]
availableLocales.forEach(locale => {
  const topLevelRoute = {
    path: `/${locale}`,
    component: {
      template: '<router-view></router-view>',
    },
    beforeEnter(to, from, next) {
      if (!locale) return next('en')
      if (!availableLocales.includes(locale)) {
        return next('en')
      }

      if (i18n.locale !== locale) {
        i18n.locale = locale
      }

      return next()
    },
    children: [],
  }
  i18n.messages[locale].routes.forEach(r => {
    topLevelRoute.children.push({
      path: `${r.url}`,
      name: `${locale}_${r.id}`,
      component: components[r.id],
    })
  })
  routes.push(topLevelRoute)
})

// export default [topLevelRoute]
export default routes
